import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { Cross } from './UiIcons';

const CloseButton = ({ handleClick }) => (
  <div className="d-flex flex-row-reverse" css={css`height: 0;`}>
    <Cross
      onClick={handleClick}
      css={css`
        cursor: pointer;
        z-index: 1;`
      }
    />
  </div>
);

CloseButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default CloseButton;
